import { all } from "redux-saga/effects";
import fetchDynamicTableSaga from "./airtable/dynamicTableSaga";
import fetchAuctionInvSaga from "./fetchAuctionInvSaga";
import submitLoginRequestSaga from "./loginSaga";
import submitOtpRequestSaga from "./otpSaga";
import fetchAllAuctionListSaga from "./fetchAllAuctionListSaga";
import submitBidPriceSaga from "./bidSubmitSaga";
import fetchFeatureSettingSaga from "./fetchFeatureSettingSaga";
import submitNbfcLoginRequestSaga from "./nbfcLoginSaga";
import createAuctionRequestSaga from "./createAuctionSaga";
import uploadedAuctionRequestSaga from "./fetchAuctionUploadedListSaga";
import fetchUploadedAuctionInvRequestSaga from "./fetchAuctionUploadedInvListSaga";
import submitUpdateBidStatusSaga from "./submitUpdateBidStatusSaga";
import fetchBidStatusSaga from "./fetchBidStatusSaga";

export default function* rootSaga() {
  yield all([
    fetchDynamicTableSaga(),
    submitLoginRequestSaga(),
    submitNbfcLoginRequestSaga(),
    submitOtpRequestSaga(),
    fetchAuctionInvSaga(),
    fetchAllAuctionListSaga(),
    submitBidPriceSaga(),
    fetchFeatureSettingSaga(),
    createAuctionRequestSaga(),
    uploadedAuctionRequestSaga(),
    fetchUploadedAuctionInvRequestSaga(),
    submitUpdateBidStatusSaga(),
    fetchBidStatusSaga()
  ]);
}